<template>
  <div>
    <div class="booking-online">
      <div v-for="(item, index) in cards.length" :key="index">
        <div class="booking-online_cards">
          <div class="booking-online_cards-title">
            <p>
              The advances in our shipping information systems have been
              designed to form a complementary part of our world-class customer
              service. Each of the following online products have been built to
              save you time and money.
            </p>
            <p>In each of our online offerings, our customers are able to:</p>
            <ul>
              <li>
                In each of our online offerings, our customers are able to:
              </li>
              <li>Create & Submit - Shipping Instructions</li>
              <li>Search Vessel Schedules</li>
              <li>Track & Trace their cargo</li>
            </ul>
            <p>
              At WR1, we are always looking to make our customers’ lives easier,
              so we have developed our own online solution, providing them
              additional features to support their daily needs: myWR1
            </p>
            <ul>
              <li>Online Bill of Lading draft visualization & approval</li>
              <li>Document downloads</li>
              <li>Arrival Notices letters</li>
              <li>Import Delivery Orders</li>
              <li>Vessel port information</li>
              <li>Cut-off information</li>
              <li>Exchange Rates information</li>
              <li>Outstanding balance on invoices issued by WR1</li>
              <li>Special payment terms overview</li>
            </ul>
            <h3><b>About myWR1</b></h3>
            <p>
              WR1 has launched a secure online portal to help customers manage
              their freight 24/7, allowing them to access real-time information
              and download documents immediately thus saving time in their daily
              operations. For more information about myWR1, please contact with
              WR1 team.
            </p>
          </div>
        </div>
      </div>
      <nav v-if="userData == null" class="booking-online-footer">
        <div>
          <h4 class="text-success">
            ONE PLATFORM FOR ALL YOUR LOGISTICS NEEDS
          </h4>
          <p class="pt-2 text-center">
            MyWR1 is your personal logistics control tower delivering end to end
            shipping services: Quotations, Bookings, Sailing Schedules and
            Shipping Instructions. Accessible 24×7, all in one place.
          </p>
          <a
            class="mt-2 btn btn-outline-success round waves-effect"
            href="/public/login"
            >Login</a
          >
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: {
    cards: {},
    className: { default: "booking-online" },
    readonly: { default: false, type: Boolean },
    view_booking: { default: null },
  },
  components: {
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
    };
  },
};
</script>
<style>
.booking-online .vue-dropzone > .dz-preview .dz-details {
  background: #2b938c;
}
.booking-online .dropzone {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}
.booking-online .select2-selection--single {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}
.booking-online .select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}
.booking-online .select2-selection__arrow {
  background: none;
  display: none !important;
}
</style>
<style lang="scss" scoped>
.booking-online-footer {
  background: #f8f7f7;
  div {
    margin: auto;
    padding: 20px 0px;
    text-align: center;
    max-width: 559px;
  }
}
.booking-online {
  position: relative;
  background: #fff;

  @media (min-width: 900px) {
    &:nth-child(1) {
      &::after {
        content: "";
        position: absolute;
        top: 36%;
        transform: translate(0, -50%);
        right: -110px;
        background-image: url("../../../../../assets/images/core-service/core-top.svg");
        background-repeat: no-repeat;
        background-size: 280px 280px;
        display: inline-block;
        width: 280px;
        height: 280px;
      }
      &::before {
        content: "";
        position: absolute;
        bottom: 110px;
        left: -120px;
        background-image: url("../../../../../assets/images/core-service/core-bottom.svg");
        background-repeat: no-repeat;
        background-size: 260px 260px;
        display: inline-block;
        width: 260px;
        height: 260px;
      }
    }
  }
  @media (min-width: 320px) {
    padding: 10px;
  }
  @media (min-width: 900px) {
    padding: 40px 70px;
  }
  @media (min-width: 1024px) {
    padding: 40px 230px;
  }
  @media (min-width: 1900px) {
    padding: 40px 470px;
  }

  &_cards {
    padding-left: 0;
    &-title {
      color: var(--text-normal-color);
      font-style: var(--normal-font-size);
      font-weight: 400;
      margin-bottom: 40px;
    }
    &-blog-card {
      display: flex;
      align-items: center;
      gap: 50px;
      flex-direction: column;
      @media (min-width: 900px) {
        flex-direction: row;
      }

      &-text {
        order: 2;
        flex: 0 0 50%;
        padding: 30px;
        padding-top: 130px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        &-title {
          color: var(--primary-color);
          font-style: var(--big-font-size);
          font-weight: 700;
        }
        &-description {
          color: var(--text-normal-color);
          font-style: var(--normal-font-size);
          font-weight: 400;
        }
      }
      &-meta {
        flex: 0 0 50%;
        order: 1;
        &-photo {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>